// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDeviceConfigurationResetDefault } from '../../services/DeviceService';
import { DeviceConfigurationReset, DeviceConfigurationResetResult } from '../../types/Devices';

type Result = UseMutationResult<DeviceConfigurationResetResult, Error, DeviceConfigurationReset>;

function usePostDeviceConfigurationResetDefault(
  successCb: (result: DeviceConfigurationResetResult) => void,
  failureCb: (error: string) => void,
): Result {
  const queryClient = useQueryClient();

  return useMutation(postDeviceConfigurationResetDefault, {
    onSuccess: (result) => {
      successCb(result);
      queryClient.invalidateQueries({ queryKey: ['device-configuration'] });
      // A reset also clears any pending test config snapshot.
      queryClient.invalidateQueries({ queryKey: ['device-test-configuration'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDeviceConfigurationResetDefault;
